import { useState, useEffect } from "react";
import { IconButton, Tooltip, Zoom, Card } from "@mui/material";
import { Edit, Error } from "@mui/icons-material";
import BTButton from "../../../components/BTButton";
import BTBox from "../../../components/BTBox";
import EnhancedTable from "../../../components/BTTable";
import DashboardLayout from "../../../Layouts/Layoutcontainers";
import AddService from "./Addservice";
import { service_price_type } from "../../../dropdownData";
import { useLoading, useNotification } from "../../../context";
import { useSelector } from "react-redux";
import { get_services } from "../../../store/functions";
const Services = () => {
  const services = useSelector((state) => state?.lab?.services);
  const [open, setOpen] = useState(null);
  const { showLoading, hideLoading } = useLoading();
  const { addNotification } = useNotification();
  const CardHeader = () => {
    return (
      <Card sx={{ mb: 1 }}>
        <BTBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          pt={2}
          pb={2}
          px={3}
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}>
          <BTButton
            variant="gradient"
            size="small"
            color="dark"
            onClick={() => setOpen({ show: true, actionType: 1 })}
            sx={{ width: { xs: "100%", sm: "auto" } }}>
            Add service
          </BTButton>
        </BTBox>
      </Card>
    );
  };
  const Actions = ({ row }) => {
    return (
      <BTBox display="flex" flexDirection={"row"} gap={1}>
        <Tooltip title="Edit" TransitionComponent={Zoom}>
          <Edit
            color="warning"
            sx={{ cursor: "pointer", fontSize: "18px" }}
            onClick={async () => {
              showLoading();
              await new Promise((resolve) => setTimeout(resolve, 1000));
              hideLoading();
              setOpen({
                actionType: 2,
                show: true,
                value: services?.data,
              });
            }}
          />
        </Tooltip>
      </BTBox>
    );
  };
  const getServices = async () => {
    showLoading();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const response = await get_services();
    if (!response?.status) {
      addNotification({
        message: response?.message?.message || "Something went wrong",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    }
    hideLoading();
  };

  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "0.1rem",
      numeric: false,
      sortable: true,
    },
    {
      id: "ser_name",
      name: "Service Name",
      cell: (row) => row?.ser_name,
      sortable: true,
      numeric: false,
      width: "150px",
    },
    {
      id: "ser_price_type",
      name: "Service Price Type",
      numeric: false,
      selector: (row) =>
        service_price_type?.find(({ value }) => value === row?.ser_price_type)
          ?.label,
      sortable: false,
      width: "150px",
    },
    {
      id: "ser_code",
      name: "Service Code",
      selector: (row) => row?.ser_code,
      numeric: false,
      sortable: true,
      width: "150px",
    },
    {
      id: "ser_time",
      name: "Service Time",
      selector: (row) => row?.ser_time,
      sortable: true,
      width: "150px",
    },
    {
      id: "ser_desc",
      name: "Description",
      selector: (row) => row?.ser_desc,
      numeric: false,
      sortable: true,
      width: "150px",
    },
    // {
    //   id: "actions",
    //   name: "Actions",
    //   selector: (row) => <Actions row={row} />,
    //   width: "80px",
    // },
  ];
  useEffect(() => {
    !services?.is_fetch && getServices();
  }, []);

  return (
    <DashboardLayout>
      <CardHeader />
      <EnhancedTable
        tableHeader={true}
        rows={services?.data?.filter(({ ser_deleted }) => !ser_deleted)}
        columns={columns}
        title="Services"
        defaultSort="carbs"
        pagination={true}
      />
      {Boolean(open) && <AddService open={open} setOpen={setOpen} />}
    </DashboardLayout>
  );
};
export default Services;
